import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ListFilters from "../../components/ohdr/ListFilters";
import type { AppDispatch, RootState } from "../../store/store";
import { useNavigate } from "react-router-dom";
import {
  resetHospitalToSchemeCodesMap,
  updateSelectedHospital,
} from "../../models/hospitalSlice";
import { successMessage } from "../../utils/notificationUtils";
import { ROUTES } from "../../utils/constants";

const ListFiltersContainer = ({
  handleFiltersChange,
  hideDateFilters,
  isShowExtraFilters = false,
}: {
  handleFiltersChange: any;
  hideDateFilters?: boolean;
  isShowExtraFilters?: boolean;
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { hospital } = useSelector((state: RootState) => state);

  const handleHospitalChange = (hospitalId: number) => {
    if (hospital.selectedHospital?.value !== hospitalId) {
      dispatch(updateSelectedHospital(hospitalId));
      dispatch(resetHospitalToSchemeCodesMap());
      successMessage("HOSPITAL UPDATE");
    }
    // navigate({ pathname: ROUTES.APPOINTMENT_LIST });
  };

  return (
    <ListFilters
      selectedHospital={hospital.selectedHospital}
      availableHospitals={hospital.availableHospitals}
      handleHospitalChange={handleHospitalChange}
      handleFiltersChange={handleFiltersChange}
      hideDateFilters={hideDateFilters}
      isShowExtraFilters={isShowExtraFilters}
    />
  );
};

export default ListFiltersContainer;
